<template>
  <f7-page id="reg-details" name="reg-details" @page:beforein="beforein" @page:afterin="afterin">
    <f7-navbar class="view-mobile no-border">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
      <div class="mb-20 pb-20">
        <div class="wandr-level-4 mt-lg mb-sm">{{$t('label-enter-pin')}}</div>
      </div>

      <div class="mt-20 pt-20">
        <transition name="fade">
          <f7-card
              :title  ="alertCard.title"
              class   ="alert alert-danger"
              v-show  ="alertCard.show"
          >
              <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
          </f7-card>
        </transition>

        <f7-list class="form-group" style="">
          <f7-list-input
            input-id      ="passwordGoogleApple"
            name          ="passwordGoogleApple"
            :type         ="passwordInputTypeGoogleApple"
            class         ="password"
            placeholder   =""
            @input        ="password = $event.target.value;validateInput($event.target);"
            minlength     ="8"
            :label        ="$t('general-text-password')"
            outline
            floating-label
            required
          >
            <div class="toggle-password" @click="showHidePassword('passwordGoogleApple')" id="password-icon" toggle="#password-field" slot="content-end" style="">
              <i class="f7-icons">eye_slash</i>
            </div>
          </f7-list-input>

          <f7-list-input
            input-id      ="password2GoogleApple"
            name          ="password2GoogleApple"
            :type         ="password2InputTypeGoogleApple"
            class         ="password"
            placeholder   =""
            @input        ="password2 = $event.target.value;validateInput($event.target);"
            minlength     ="8"
            :label        ="$t('general-text-reenter-password')"
            outline
            floating-label
            required
          >
            <div class="toggle-password" @click="showHidePassword('password2GoogleApple')" id="password-icon2" toggle="#password-field2" slot="content-end" style="">
              <i class="f7-icons">eye_slash</i>
            </div>
          </f7-list-input>
        </f7-list>
      </div>

      <f7-button class="mb-sm mt-xl" large fill @click="goToNextPage" :disabled="!isPasswordValid || !isPassword2Valid">
        {{$t('general-btn-submit')}}
      </f7-button>

    </f7-block>
  </f7-page>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import CryptoAES from 'aes-ecb'
  import store from '../../store'
  import ApiService from "../../services/api-main";
  import TokenService from '../../services/token-service';
  import { check } from '@/plugins/helper';

  export default {
    mounted (){

    },
    data() {
      return {
        password              : "",
        password2             : "",
        isPasswordValid       : false,
        isPassword2Valid      : false,
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        passwordInputTypeGoogleApple     : "password",
        password2InputTypeGoogleApple    : "password",
      };
    },
    methods: {
      ...mapActions('registration', ['getTokenByGoogleAppleSignIn']),
      beforein(){
        console.log("register enter password page, AXS ? "+this.isAxsr)
      },
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      validateInput(e) {
        var inputName   = e.name;
        var inputValue  = "";
        var keyName     = e.name == "passwordGoogleApple" ? "regis-password" : "regis-password2";
        var translation;

        if(e.name == "passwordGoogleApple"){
          inputValue = this.password;
        }else{
          inputValue = this.password2;
        }

        if (inputValue == ""){
          translation = keyName + "-empty";
          this.setInputState(inputName, this.$t(translation));
          return false;
        }

        //var regex = /^[0-9]{6}$/;
        var validate = false;
        if(inputName == "passwordGoogleApple" || inputName == "password2GoogleApple"){
          validate   = check.validPattern("password", e.value);
        }

        if(!validate){
          translation = keyName + "-rule";
          this.setInputState(inputName, this.$t(translation));
          if(inputName == "passwordGoogleApple"){
            this.isPasswordValid = false;
          }else if(inputName == "password2GoogleApple"){
            this.isPassword2Valid = false;
          }
          return false;
        }

        if(inputName == "passwordGoogleApple"){
          this.isPasswordValid = true;
        }else if(inputName == "password2GoogleApple"){
          this.isPassword2Valid = true;
        }

        if (inputName == "passwordGoogleApple"){
            if(this.password2.trim() != ""){
                if( this.password != this.password2){
                    translation = "regis-password2-mismatch";
                    this.setInputState("password2GoogleApple", this.$t(translation));
                    this.isPassword2Valid = false;
                    this.isNextButtonValid = false;

                    if(validate){
                        this.isPasswordValid = true;
                        this.setInputState("passwordGoogleApple", true);
                    }
                    return false;
                  }else{
                    this.isPasswordValid = true;
                    this.isPassword2Valid = true;
                    this.setInputState("passwordGoogleApple", true);
                    this.setInputState("password2GoogleApple", true);
                  }
            }
        }

        if (inputName == "password2GoogleApple"){
          if( this.password != this.password2){
            translation = keyName + "-mismatch";
            this.setInputState(inputName, this.$t(translation));
            this.isPasswordValid = false;
            this.isPassword2Valid = false;
            return false;
          }else{
            this.isPasswordValid = true;
            this.isPassword2Valid = true;
          }
        }

        this.setInputState(inputName, true);
        return true;
      },
      async goToNextPage(){
        this.showPreloader();

        // var today = new Date();
        // var dd = String(today.getDate()).padStart(2, '0');
        // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yy = today.getFullYear().toString().substr(-2);
        // var todayNew = MM + dd + yy;
        const randVal = await ApiService.getRandomValue();

        var secretKey = process.env.VUE_APP_PSSTK+randVal;
        //console.log("secret key : "+secretKey)

        var registrationData = store.state.registration;
        registrationData.password = CryptoAES.encrypt(secretKey, this.password);
        registrationData.password2 = CryptoAES.encrypt(secretKey, this.password2);

        const reqToken = await this.$api.registration.getTokenByGoogleAppleSignIn(registrationData);
        if(reqToken.status == "WN00103"){
            //this.$f7router.navigate("/register-mobile-no");
            this.$f7router.navigate("/register-tnc");
            this.hidePreloader();
        }else if(reqToken.status == "WN00102"){ // email exist
            this.showAlert(true, this.$t('regis-email-exist'));
            this.hidePreloader();
        }else{
            this.showAlert(true, reqToken.status)
            console.log("REQUEST REGISTER TOKEN ERROR! Status : "+reqToken.status);
            this.hidePreloader();
        }
      },
      backButton() {
          if(this.isAxsr){
            // clear singpass token
            TokenService.removeToken()
            this.$f7router.navigate("/customerDetails");
          }else{
            switch(this.routerTo) {
                default          : this.$f7router.navigate("/"); break;
            }
          }
      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      showHidePassword(el){
        let $$ = this.Dom7;

        if(el == "passwordGoogleApple"){
          if(this.passwordInputTypeGoogleApple == "password"){
            this.passwordInputTypeGoogleApple = "text";
            $$("#password-icon").html('<i class="f7-icons">eye</i>');
          }else{
            this.passwordInputTypeGoogleApple = "password";
            $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
          }

        } else if(el == "password2GoogleApple"){
          if(this.password2InputTypeGoogleApple == "password"){
            this.password2InputTypeGoogleApple = "text";
            $$("#password-icon2").html('<i class="f7-icons">eye</i>');
          }else{
            this.password2InputTypeGoogleApple = "password";
            $$("#password-icon2").html('<i class="f7-icons">eye_slash</i>');
          }
        }
      }
    },
    components: {

    },
    computed: {
      ...mapGetters('registration', [
          'isAxsr'
        ]),
    },
  }
</script>